import { useEffect, useState } from 'react'

const MIN_KEYBOARD_HEIGHT = 300

export const useKeyboardIsVisible = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false)

  useEffect(() => {
    const listener = () => {
      const newState = window.screen.height - MIN_KEYBOARD_HEIGHT > (window?.visualViewport?.height || 0)
      if (isKeyboardOpen != newState) {
        setIsKeyboardOpen(newState)
      }
    }
    if (typeof visualViewport != 'undefined') {
      window?.visualViewport?.addEventListener('resize', listener)
    }
    return () => {
      if (typeof visualViewport != 'undefined') {
        window?.visualViewport?.removeEventListener('resize', listener)
      }
    }
  }, [isKeyboardOpen, setIsKeyboardOpen])

  return { isKeyboardOpen }
}
